interface VatNoData {
  label: string
  formatExample?: string
}

interface RegistrationNoData {
  label: string
}

interface CountryTaxFieldData {
  vatNo?: VatNoData
  registrationNo: RegistrationNoData
}

const countryTaxFieldData: Record<string, CountryTaxFieldData> = {
  DE: {
    registrationNo: { label: 'Steuernummer' },
    vatNo: { label: 'USt-IdNr', formatExample: 'DE123456789' },
  },
  DK: {
    registrationNo: { label: 'CVR' },
  },
  FR: {
    registrationNo: { label: 'SIRET' },
    vatNo: { label: 'TVA', formatExample: 'FRxx345678901' },
  },
  NL: {
    registrationNo: { label: 'KvK' },
    vatNo: { label: 'BTW', formatExample: 'NL123456789B01' },
  },
}

export const getCountryTaxFieldData = (countryId: string | undefined): CountryTaxFieldData | undefined =>
  countryId ? countryTaxFieldData[countryId] : undefined
